import { defineMessages } from 'react-intl'

/**
 * Cruise cabin categories and cruise-type labels — `docs/product-taxonomy.md` §8.
 * Cabin copy aligns with `useCruiseCabinTypeLabels` message ids; browse-all-offers live in `commonMessages`.
 */
const cruiseGlossaryMessages = defineMessages({
  cabinInside: {
    id: 'dP5SBpYTiHJM8qoNcbG1',
    defaultMessage: 'Inside',
    description: 'Cruise cabin type label for inside cabins in search filters and cabin selection',
  },
  cabinOceanview: {
    id: 'oFZejcnGLNDbKiZNTED3',
    defaultMessage: 'Oceanview',
    description: 'Cruise cabin type label for oceanview cabins in search filters and cabin selection',
  },
  cabinWindow: {
    id: '_1r-SSkOV2jY4rBj8TG6',
    defaultMessage: 'Window',
    description: 'Cruise cabin type label for window cabins where shown separately from full oceanview',
  },
  cabinBalcony: {
    id: 'qi3xPZY-i04mnMod7pL5',
    defaultMessage: 'Balcony',
    description: 'Cruise cabin type label for balcony cabins in search filters and cabin selection',
  },
  cabinSuite: {
    id: 'NykjyKOOj9ZcCTmxnLrC',
    defaultMessage: 'Suite',
    description: 'Cruise cabin type label for suite cabins in search filters and cabin selection',
  },
  oceanviewOrWindow: {
    id: 'mKXvvvoFCvipozxdmC8Z',
    defaultMessage: 'Oceanview / Window',
    description: 'Cruise cabin combined label for oceanview or window stateroom types in search UI',
  },
  oceanCruise: {
    defaultMessage: 'Ocean cruise',
    id: 'TgX1wB57hr3VpcOvULKc',
    description: 'High-level product filter or hero label for ocean-going cruise product vertical',
  },
  riverCruise: {
    defaultMessage: 'River cruise',
    id: 'ye0H19kHDMBo4H7wqaD9',
    description: 'High-level product filter or hero label for river cruise product vertical',
  },
  allCruiseLines: {
    defaultMessage: 'All cruise lines',
    id: 'Ta4_XJUPNJokupWv9Cd0',
    description: 'Filter or nav label to show inventory across all available cruise line partners',
  },
})

export default cruiseGlossaryMessages
